'use strict';

module.exports = require('react').createClass;




//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/react/static-7.41/create-react-class.js
// module id = 28
// module chunks = 0